console.log('[cstm-sticky] file loaded — VERSION anchor-v3');

(() => {
  const init = () => {
    const forms = document.querySelectorAll('product-form.product-form');
    console.log('[cstm-sticky] init — forms found:', forms.length);

    forms.forEach((form, i) => {
      if (form.dataset.cstmStickyBound) {
        console.log('[cstm-sticky] form', i, 'already bound — skipping');
        return;
      }
      form.dataset.cstmStickyBound = 'true';

      const anchor = document.createElement('div');
      anchor.className = 'cstm-sticky-anchor';
      anchor.setAttribute('aria-hidden', 'true');
      anchor.style.cssText = 'display:block;height:1px;';
      form.parentNode.insertBefore(anchor, form);

      console.log('[cstm-sticky] form', i, 'bound — anchor inserted:', anchor);

      new IntersectionObserver(
        ([entry]) => {
          const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          form.classList.toggle('sticky-product-form', past);
          console.log('[cstm-sticky] form', i, '| top:', Math.round(entry.boundingClientRect.top), '| sticky:', past);
        },
        { threshold: 0 }
      ).observe(anchor);
    });
  };

  if (document.readyState === 'loading') {
    console.log('[cstm-sticky] waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', init);
  } else {
    console.log('[cstm-sticky] DOM ready — init now');
    init();
  }
})();